import script from "./OTP-Form.vue?vue&type=script&setup=true&lang=js"
export * from "./OTP-Form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__